export const profileRoutes = {
	profileIndex: '/profile',
	profilePasswordChange: '/profile/password-change'
} as const
